// Same stylesheet the Mantine half loads — the legacy Tabler side names the same
// families in `application.scss`, so both halves have to resolve to the same files or
// the two rendering engines drift apart on the same page.
import '@skie-io/react/fonts.css'
import '@hotwired/turbo-rails'
import 'bootstrap'
import { init as initI18n } from '~/i18n'
import { init as initSentry } from '~/sentry'

initSentry()
await initI18n()
